import { IApplicationState } from "../state";
import { createSelector } from "@reduxjs/toolkit";

const languageStateSelector = (state: IApplicationState) => state.language;

export const activeLanguageSelector = createSelector(
    languageStateSelector,
    (languageState) => languageState.activeLanguage
);
